import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'active', label: 'Active' },
  { value: 'dormant', label: 'Dormant' },
  { value: 'deregistered', label: 'Deregistered' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'name', label: 'Employer' },
  { key: 'registration_number', label: 'Registration #' },
  { key: 'tin', label: 'TIN' },
  { key: 'contact_person', label: 'Contact Person' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'industry_sector', label: 'Industry Sector' },
  { key: 'contribution_frequency', label: 'Contribution Frequency' },
  { key: 'status', label: 'Status' },
];

export function EmployerRegisterReport() {
  return (
    <ReportView
      title="Employer Register"
      description="Full employer listing with registration, contact and contribution details."
      endpoint="/reports/memberships/employer-register"
      columns={COLUMNS}
      filters={['status']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
